import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'file360-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgressBarComponent implements OnInit {

  /** Value of the progres meter */
  private _value: number = 0;
  private lastValueSet: Date = new Date();

  /**
   * Get the value of the progress bar.
   */
  get value() {
    return this._value;
  }

  /**
   * Set the value of the progress bar. The progress will ignore some values if it is changed too quickly.
   */
  @Input() set value(val: number) {
    /**
     * See https://github.com/angular/material2/issues/15138
     * 
     * Updating the progress value too quickly causes the progress bar to appear choppy and the even regresses the bar.
     * This is because the CSS transition is 250ms but the value is updating faster
     * than this. One possible solution is to slow the transition duration down on .mat-progress-bar .mat-progress-bar-fill,
     * but this also makes the animation also appear choppy. Instead, this solution restricts updating the progress value
     * so values are ignored when updated too quickly. Certain exceptions are allowed.
     */
    let currentDate: Date = new Date();
    currentDate.setMilliseconds(-500);
    if (currentDate > this.lastValueSet
      || val == 100 ||
      this._value == 0) {
      this._value = val;
      this.lastValueSet = new Date();
    }
  }

  constructor() { }

  ngOnInit() {
  }

}
